module.exports = __webpack_public_path__ + "static/img/pattern_1.26c52d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pattern_1.svg
// module id = iKbO
// module chunks = 1